<template>
    <svg width="14" height="14" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.667 5.281v6.546a.613.613 0 01-.614.61H1.842a.613.613 0 01-.615-.61V2.665c0-.337.275-.611.615-.611h6.406L9.486.832H1.842A1.84 1.84 0 00-.001 2.665v9.162a1.84 1.84 0 001.843 1.832h9.211a1.84 1.84 0 001.842-1.832V4.069L11.667 5.28z" fill="#fff"/><path fill-rule="evenodd" clip-rule="evenodd" d="M5.648 6.678L5.177 8.43l1.777-.461 6.7-6.677L12.348 0l-6.7 6.678z" fill="#fff"/></svg>
</template>

<script>
    export default {
        name: "NewMessage"
    }
</script>